import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MusicsCard from '../components/MusicCardComponent';
import { setPlaylist } from '../../../common/Playlist/actions/PlaylistActions';
import { pauseMediaPlayer, playMediaPlayer } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state) => ({
    // MediaPlayer
    playerStatus: state.aovivoBar.MediaPlayer.playerStatus,
    // Playlist
    currentIndex: state.playlist.currentIndex,
    currentMusicId: state.playlist.currentMusicId,
    filteredMusics: state.musics.musicsPage.filteredMusics,
    isLive: state.aovivoBar.MediaPlayer.isLive,
});

const mapDispatchToProps = (dispatch) => ({
    setPlaylist: (playlistType, trackList, currentIndex, currentMusicId) => dispatch(
        setPlaylist(playlistType, trackList, currentIndex, currentMusicId),
    ),
    pauseMediaPlayer: () => dispatch(pauseMediaPlayer()),
    playMediaPlayer: () => dispatch(playMediaPlayer()),
});

const MusicCardContainer = connect(mapStateToProps, mapDispatchToProps)(
    ({
        currentMusicId,
        playMediaPlayer: dispatchPlayMediaPlayer,
        pauseMediaPlayer: dispatchPauseMediaPlayer,
        setPlaylist: dispatchSetPlaylist,
        playerStatus,
        playlistType,
        isLive,
        useFilteredMusics,
        playlistData,
        filteredMusics,
        music,
        showDownloadButton,
        musicIndex,
    }) => (
        <MusicsCard
            currentMusicId={currentMusicId}
            playMediaPlayer={dispatchPlayMediaPlayer}
            pauseMediaPlayer={dispatchPauseMediaPlayer}
            setPlaylist={dispatchSetPlaylist}
            playerStatus={playerStatus}
            playlistType={playlistType}
            isLive={isLive}
            useFilteredMusics={useFilteredMusics}
            playlistData={playlistData}
            filteredMusics={filteredMusics}
            music={music}
            showDownloadButton={showDownloadButton}
            musicIndex={musicIndex}
        />
    ),
);

export default withRouter(MusicCardContainer);
